import { render, staticRenderFns } from "./AddFlight.vue?vue&type=template&id=50c433eb&"
import script from "./AddFlight.vue?vue&type=script&lang=js&"
export * from "./AddFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports